import { useEffect, useState } from 'react';
import { type Editor } from '@meitu/saas-editor-core';
import { TextEditPlugin } from '@meitu/saas-editor-core/es/plugins/text-edit';
import { type EditingRange } from '@meitu/saas-editor-core/es/version-types';

export const useEditingRange = (editor: Editor) => {
    const [editingRange, setEditingRange] = useState<EditingRange | null>(null);

    useEffect(() => {
        const currentEditingRange = editor.getInstance(TextEditPlugin).getEditingRange();
        setEditingRange(currentEditingRange);

        const dispose = editor.getInstance(TextEditPlugin).onEditingRangeChange((range) => {
            setEditingRange(range);
        });

        return dispose;
    }, []);

    return editingRange;
};
